export default {
  parts: 'Peças',

  'parts.entity.name': 'Nome',
  'parts.entity.description': 'Descrição',
  'parts.entity.partApplicationDescription': 'Descrição da Aplicação',
  'parts.entity.barCode': 'Código de Barras',
  'parts.entity.manufacturer': 'Fabricante',
  'parts.entity.sku': 'Cód. Interno',
  'parts.entity.companyCode': 'Cód. Empresa',
  'parts.entity.manufacturerCode': 'Cód. Fabricante',
  'parts.entity.manufacturingCode': 'Cód. Marca',
  'parts.entity.originalCode': 'Cód. Interno',
  'parts.entity.includeInDiagnosis': 'Incluir em diagnóstico',
  'parts.entity.lifeSpan': 'Vida útil (dias)',
  'parts.entity.cfop': 'CFOP',
  'parts.entity.ncm': 'NCM',
  'parts.entity.unit': 'Unidade',
  'parts.entity.subGroup': 'Grupo',
  'parts.entity.kmToMaintenance': 'Km manutenção',
  'parts.entity.netWeight': 'Peso líquido',
  'parts.entity.grossWeight': 'Peso bruto',
  'parts.entity.comment': 'Observações',
  'parts.entity.addPartImage': 'Adicionar Imagem do Produto',
  'parts.entity.location': 'Localização',

  'parts.create': 'Criar Nova Peça',
  'parts.create.notifications.success.title': 'Sucesso',
  'parts.create.notifications.success.description': 'Peça criada.',

  'parts.details': 'Detalhes da Peça',

  'parts.update.notifications.success.title': 'Sucesso',
  'parts.update.notifications.success.description': 'Peça atualizada.',

  'parts.remove.confirm.title': 'Remover peça',
  'parts.remove.confirm.content':
    'Deseja realmente remover a peça selecionada?',
  'parts.remove.success.message': 'Sucesso',
  'parts.remove.success.description': 'Peça removida.',

  'parts.changePrices': 'Alterar Preços',

  'parts.stock': 'Estoque',
  'parts.stock.domain.company': 'Empresa',
  'parts.stock.domain.stock': 'Estoque',
  'parts.stock.domain.availableStock': 'Estoque Disponível',
  'parts.stock.domain.sellPrice': '(R$) Preço de Venda',
  'parts.stock.domain.commissionPercentage': '(%) Comissão',
  'parts.stock.domain.minStock': 'Est. Mínimo',
  'parts.stock.domain.maxStock': 'Est. Máximo',
  'parts.stock.domain.buyPrice': '(R$) Pr. Custo',
  'parts.stock.domain.ipi': '(%) IPI',
  'parts.stock.domain.taxReplacement': '(R$) Subs. Tributária',
  'parts.stock.domain.fixedCost': '(%) Custo Fixo',
  'parts.stock.domain.icmsExemption': '(R$) ICMS Deson.',
  'parts.stock.domain.freightCost': '(R$) Valor Frete',
  'parts.stock.domain.otherExpenses': '(R$) Outras Despesas',
  'parts.stock.domain.realCost': '(R$) Custo Real',
  'parts.stock.domain.maxDiscount': '(%) Max. Desconto',
  'parts.stock.domain.location': 'Localização',
  'parts.stock.domain.profitMargin': '(%) Margem de lucro',

  'parts.lastPurchases.domain.code': 'Número da compra',
  'parts.lastPurchases.domain.supplier': 'Fornecedor',
  'parts.lastPurchases.domain.issueDate': 'Data da emissão',
  'parts.lastPurchases.domain.releaseDate': 'Data de lançamento',
  'parts.lastPurchases.domain.quantity': 'Quantidade',
  'parts.lastPurchases.domain.unitaryValue': 'Valor unitário',
  'parts.lastPurchases.domain.totalAmountItem': 'Valor total',
  'parts.lastPurchases.domain.averageCostLastPurchases':
    'Valor médio de custo da peça nas últimas compras: ',

  'parts.stock.enabledCostFields':
    'Para a empresa selecionada: {company}, os seguintes campos fazem parte do cálculo do "Custo Real"',

  'parts.stock.update.notifications.success.title': 'Sucesso',
  'parts.stock.update.notifications.success.description':
    'Configurações de estoque da empresa foram atualizadas.',

  'parts.application.modal.form.brand': 'Montadora',
  'parts.application.modal.form.model': 'Modelo',
  'parts.application.modal.form.fromYear': 'Ano Inicial',
  'parts.application.modal.form.toYear': 'Ano Final',

  'parts.application.modal.create.success.title': 'Sucesso!',
  'parts.application.modal.create.success.description':
    'Aplicação da peça criada!',
  'parts.application.modal.remove.title': 'Remover Aplicação',
  'parts.application.modal.remove.content':
    'Realmente você deseja remover essa aplicação, ao confirmar será deletada da base de dados. Ainda assim deseja continuar?',
  'parts.application.modal.remove.success.description':
    'Aplicação removida com sucesso!',

  'parts.generateReport': 'Gerar Relatório',
  'parts.modal.report.title': 'Gerar Relatório',
  'parts.modal.report.buttons.viewReport': 'Visualizar Relatório',
  'parts.modal.report.buttons.pdf': 'Gerar PDF',
  'parts.modal.report.buttons.rtf': 'Gerar RTF',
  'parts.modal.report.buttons.csv': 'Gerar CSV',
  'parts.modal.report.form.description': 'Descrição',
  'parts.modal.report.form.group': 'Grupo',
  'parts.modal.report.form.manufacturers': 'Fabricante',
  'parts.modal.report.form.companies': 'Empresas',
  'parts.modal.report.form.localization': 'Localização, De',
  'parts.modal.report.form.localizationUpUntil': 'Até',
  'parts.modal.report.form.detailTheProducts': 'Detalhar os produtos',
  'parts.modal.report.form.viewPartApplication': 'Exibir aplicação da peça',
  'parts.modal.report.form.viewActualCostPart': 'Exibir custo real da peça',
  'parts.modal.report.form.showPartCodesOnCSV': 'Exibir códigos da peça no CSV',
  'parts.modal.report.form.showPartCfop': 'Exibir CFOP da peça',
  'parts.modal.report.form.inhibitPartsStockWithZero':
    'Inibir peças com estoque zerado?',
  'parts.modal.report.form.yes': 'Sim',
  'parts.modal.report.form.no': 'Não',
  'parts.modal.report.form.order': 'Ordem',
  'parts.modal.report.form.descriptionOrder': 'Descrição',
  'parts.modal.report.form.localization': 'Localização',
  'parts.modal.report.form.internalCode': 'Código Interno',

  'parts.partsReplacement.part': 'Peça',
  'parts.partsReplacement.modal.title': 'Selecionar Peça',
  'parts.partsReplacement.modal.description': 'Descrição',
  'parts.partsReplacement.modal.manufacturingCode': 'Código de Fabricação',
  'parts.partsReplacement.modal.barCode': 'Código de Barra',
  'parts.partsReplacement.modal.internalCode': 'Código Interno',
  'parts.partsReplacement.modal.companyCode': 'Código da Empresa',

  'parts.partsReplacement.filters.manufacturingCode': 'Código de Fabricação',
  'parts.partsReplacement.filters.barCode': 'Código de Barra',
  'parts.partsReplacement.filters.internalCode': 'Código Interno',
  'parts.partsReplacement.filters.companyCode': 'Código da Empresa',

  'parts.partsReplacement.btn.addReplacementPart': 'Adicionar Peça Substituta',
  'parts.partsReplacement.btn.addReplacementPartLink':
    'Adicionar Peça Substituta e vincular as demais peças relacionadas',

  'parts.partsReplacement.create.notification.success': 'Sucesso',
  'parts.partsReplacement.create.notification.successDescription':
    'Peça substituta criada.',

  'parts.partsReplacement.create.notification.removeDescription':
    'Peça substituta removida.',

  'parts.consultation.application.internalCode': 'Código Interno',
  'parts.consultation.application.manufacturerCode': 'Código de Fabricação',
  'parts.consultation.application.description': 'Descrição',
  'parts.consultation.application.stock': 'Estoque',
  'parts.consultation.application.salePrice': 'Preço de Venda',
  'parts.consultation.application.localization': 'Localização',
  'parts.consultation.application.btn.select': 'Selecionar',

  'parts.status.message.success': 'Status da peça alterado com sucesso!',

  'parts.error.internalCode.alreadyExists':
    'Já existe uma peça cadastrada com esse código interno',
  'parts.error.barCode.alreadyExists':
    'Já existe uma peça cadastrada com esse código de barras',
  'parts.error.remove.bonds':
    'Não foi possível concluir a ação devido a violação nos vínculos desse registro!',
};
